export default {
  label: {
    title: {
      removeCards: 'Remove {count} components',
      removeCard: 'Remove {count} component',
    },
    button: {
      cancel: 'Cancel',
      remove: 'Remove',
    },
  },
};
